import {dopeTitleSEO} from 'definitions/constant'
import {Pathname} from 'interfaces/Routes.types'
import {SEOData} from 'interfaces/SEO.types'
import {useEffect, useState} from 'react'

/**
 * useSEO hook to get title and description based on pathname
 * @param pathname - string or array of strings
 * @returns title - string, description - string
 */
export const useSEO = (pathname: Pathname): SEOData => {
  const [seoData, setSeoData] = useState<SEOData>({
    title: dopeTitleSEO,
    description: '',
  })

  // Helper function to extract base path from pathname
  const getBasePath = (pathname: Pathname): string => {
    const path = Array.isArray(pathname) ? pathname[0] : pathname
    const basePath = path.split('/')[1]
    return basePath || ''
  }

  // update title and description based on pathname
  useEffect(() => {
    const basePath = getBasePath(pathname)

    switch (basePath) {
      case 'analytics':
        setSeoData({
          title: 'analytics',
          description: 'analytics',
        })
        break
      case 'settings':
        setSeoData({
          title: 'settings',
          description: 'settings',
        })
        break
      case 'policies':
        setSeoData({
          title: 'SWG',
          description: 'SWG',
        })
        break
      case 'endpoints':
        setSeoData({
          title: 'endpoints',
          description: 'endpoints',
        })
        break
      case 'casb':
        setSeoData({
          title: 'casb',
          description: 'casb',
        })
        break
      case 'onboarding':
        setSeoData({
          title: 'onboarding',
          description: 'onboarding',
        })
        break
      default:
        setSeoData({
          title: 'Page Not Found',
          description: '',
        })
    }
  }, [pathname])

  return seoData
}
